import React from 'react';

function GenerateButton(props) {

  const{data, handleClick} = props;

  return  (
    <div className="row">
      <div className="col-xs-12">
        <div className="nppe2-fc-print-pdf">
          <div
          className="nppe2-fc-print-pdf__btn"
          onClick={handleClick}
          >

            <div className="nppe2-fc-print-pdf__text">
              {data.generate}
            </div>

            <div className="nppe2-fc-print-pdf__icon">
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default GenerateButton;
